import dynamic from 'next/dynamic'

export const ContentStackLivePreviewWebComponent = dynamic(
  () => {
    return import('~/lib/contentstack/ContentStackInitialize')
  },
  { ssr: false }
)
